<ng-container *ngFor="let historyItemRow of historyItemRows">
  <ng-container *ngIf="!historyItemRow.hidden">
    <div class="cs-detail--row w-100 py-1" *ngIf="history?.[historyItemRow.field]">
      <span class="color-muted">{{ historyItemRow.title }}:</span>
      <span class="color-dark">{{ getFieldValue(historyItemRow) }}</span>
    </div>
  </ng-container>
</ng-container>